
import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import { email, minLength, required } from 'vuelidate/lib/validators'
import { ICreateEmployee, IEmployeeRoles } from '@/types/employees'
import { addEmployee, availableRoles, checkEmail, createEmployee } from '@/connectors/employees'
import { Endpoints } from '@/connectors/endpoints'

export default Vue.extend({
  name: 'EmployeesFormWizard',
  components: { Multiselect },
  data () {
    return {
      emailAvailable: true,
      employee: {
        name: '',
        email: '',
        password: '',
        position: ''
      } as ICreateEmployee,
      roles: [] as IEmployeeRoles[],
      selectedRoles: []
    }
  },
  mounted () {
    this.availableRoles()
  },
  methods: {
    availableRoles () {
      availableRoles(Endpoints.AVAILABLE_ROLES)
        .then(res => {
          this.roles = res
        }).catch(e => {
          console.error(e.response)
          this.$bvModal.show('errorModal')
        })
    },
    createEmployee () {
      this.$v.$touch()
      if (this.$v.$error || !this.selectedRoles.length) {
        return
      }
      checkEmail(this.employee.email, Endpoints.CHECK_EMAIL)
        .then(res => {
          if (res.data.email_available) {
            this.emailAvailable = true
            this.employee.moid = this.$store.state.profile.select_organization.id
            this.employee.roles = this.selectedRoles.map((role: IEmployeeRoles) => role.name)
            createEmployee(this.employee, Endpoints.CREATE_EMPLOYEE)
              .then(() => {
                this.$router.push('/app/house_wizard')
              }).catch(e => {
                console.error(e.response)
                // @ts-ignore
                this.$showErrorToast(e.response.data.message)
              })
          } else {
            this.emailAvailable = false
          }
        }).catch(e => {
          console.error(e.response)
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    },
    addEmployee () {
      this.employee.moid = this.$store.state.profile.select_organization.id
      this.employee.roles = this.selectedRoles.map((role: IEmployeeRoles) => role.name)
      addEmployee(this.employee, Endpoints.ADD_EMPLOYEE).then(() => {
        this.emailAvailable = true
        this.$router.push('/app/house_wizard')
      }).catch(e => {
        this.emailAvailable = true
        console.error(e.response)
        // @ts-ignore
        this.$showErrorToast(e.response.data.message)
      })
    }
  },
  validations: {
    selectedRoles: {
      required,
      minLength: minLength(1)
    },
    employee: {
      name: {
        required
      },
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(6)
      },
      position: {
        required
      }
    }
  }
})
